export const TimesheetContractType = {
    Internal: true,
    External: false
};
